import React from 'react';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import { Textarea } from '../ui/Textarea';
import { Checkbox } from '../ui/Checkbox'; // Assuming Checkbox exists or using input
import { FileText, CheckSquare, Upload } from 'lucide-react';
interface ReportModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function ReportModal({
  isOpen,
  onClose
}: ReportModalProps) {
  return <Modal isOpen={isOpen} onClose={onClose} title="Compila Report Sopralluogo" size="2xl" data-id="element-269">
      <div className="space-y-8" data-id="element-270">
        <section data-id="element-271">
          <h4 className="text-sm font-bold text-seform-navy uppercase tracking-wider mb-4 flex items-center gap-2" data-id="element-272">
            <FileText className="h-4 w-4" data-id="element-273" /> Resoconto Attività
          </h4>
          <Textarea label="Descrizione attività svolta" placeholder="Descrivi dettagliatamente cosa è stato fatto..." rows={5} data-id="element-274" />
        </section>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-275">
          <section className="bg-slate-50 p-4 rounded-xl border border-slate-200" data-id="element-276">
            <h4 className="font-bold text-seform-navy mb-3" data-id="element-277">
              Cosa fa il consulente
            </h4>
            <ul className="space-y-2 mb-3" data-id="element-278">
              <li className="flex items-center gap-2 text-sm text-slate-700" data-id="element-279">
                • Redazione DVR
              </li>
            </ul>
            <Button size="sm" variant="flat" fullWidth data-id="element-280">
              + Aggiungi punto
            </Button>
          </section>

          <section className="bg-slate-50 p-4 rounded-xl border border-slate-200" data-id="element-281">
            <h4 className="font-bold text-seform-navy mb-3" data-id="element-282">
              Cosa fa il cliente
            </h4>
            <ul className="space-y-2 mb-3" data-id="element-283">
              <li className="flex items-center gap-2 text-sm text-slate-700" data-id="element-284">
                • Inviare planimetrie
              </li>
            </ul>
            <Button size="sm" variant="flat" fullWidth data-id="element-285">
              + Aggiungi punto
            </Button>
          </section>
        </div>

        <section data-id="element-286">
          <h4 className="text-sm font-bold text-seform-navy uppercase tracking-wider mb-4 flex items-center gap-2" data-id="element-287">
            <CheckSquare className="h-4 w-4" data-id="element-288" /> Collegamenti
          </h4>
          <div className="grid grid-cols-2 gap-4" data-id="element-289">
            <label className="flex items-center gap-2 p-3 border rounded-lg hover:bg-slate-50 cursor-pointer" data-id="element-290">
              <input type="checkbox" className="rounded text-seform-orange focus:ring-seform-orange" data-id="element-291" />
              <span className="text-sm font-medium" data-id="element-292">
                Non Conformità rilevate
              </span>
            </label>
            <label className="flex items-center gap-2 p-3 border rounded-lg hover:bg-slate-50 cursor-pointer" data-id="element-293">
              <input type="checkbox" className="rounded text-seform-orange focus:ring-seform-orange" data-id="element-294" />
              <span className="text-sm font-medium" data-id="element-295">
                Miglioramenti proposti
              </span>
            </label>
          </div>
        </section>

        <section data-id="element-296">
          <div className="border-2 border-dashed border-slate-300 rounded-xl p-8 text-center hover:bg-slate-50 cursor-pointer transition-colors" data-id="element-297">
            <Upload className="h-8 w-8 text-slate-400 mx-auto mb-2" data-id="element-298" />
            <p className="text-sm text-slate-600 font-medium" data-id="element-299">
              Clicca per caricare foto o documenti
            </p>
            <p className="text-xs text-slate-400" data-id="element-300">JPG, PNG, PDF fino a 10MB</p>
          </div>
        </section>

        <div className="flex justify-end gap-3 pt-4 border-t border-slate-100" data-id="element-301">
          <Button variant="flat" color="default" onClick={onClose} data-id="element-302">
            Salva Bozza
          </Button>
          <Button onClick={onClose} data-id="element-303">Completa e Firma</Button>
        </div>
      </div>
    </Modal>;
}